import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { PopoverCode } from './codeHighlights/PopverCode';
import Script from 'next/script';

interface PopoverProps {
  styles: string;
  placement?: 'top' | 'right' | 'bottom' | 'left';
}

export const PopOver = ({ styles, placement = 'left' }: PopoverProps) => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      const popoverNode = document.querySelector('.popover.show');
      if (popoverNode) {
        popoverNode.classList.remove('show');
      }
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  });

  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-6">
          <button
            type="button"
            className={styles}
            data-bs-toggle="popover"
            data-bs-placement="bottom"
            data-bs-trigger="hover focus"
            title="Popover title"
            data-bs-content="And here's some amazing content. It's very engaging. Right?"
          >
            Hover to toggle popover
          </button>

          <div className="mt-5">
            <Script id="popover" type="module">
              {`
              var popoverTriggerList = [].slice.call(
                document.querySelectorAll('[data-bs-toggle="popover"]')
              );
            
              var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
              return new bootstrap.Popover(popoverTriggerEl);
              });
            `}
            </Script>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <button
            type="button"
            className={styles}
            data-bs-toggle="popover2"
            data-bs-placement="top"
            data-bs-trigger="click"
            title="Popover title"
            data-bs-content="And here's some amazing content. It's very engaging. Top?"
          >
            Click to toggle popover
          </button>

          <div className="mt-5">
            <Script id="popover2" type="module">
              {`
          var popoverTriggerList = [].slice.call(
            document.querySelectorAll('[data-bs-toggle="popover2"]')
            );
            
            var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
              return new bootstrap.Popover(popoverTriggerEl);
            });
            `}
            </Script>
          </div>
        </div>
        <div className="col-12 mt-5">
          <PopoverCode />
        </div>
      </div>
    </>
  );
};
